import React, { useState, useEffect } from 'react';
import { makeStyles, Button, Paper, Switch, FormGroup, FormControlLabel } from '@material-ui/core';
import { NavLink } from "react-router-dom";
import ClientDevexGrid from './../Client/ClientDevexGrid';
import { toast } from 'react-toastify';
import { clientDataService } from './../../Services/clientDataService';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import DeleteDialog from './../Client/DeleteDialog';
import AddEditDrawer from './../Client/AddEditDrawer';


export default function ClientsPage() {
    const [rows, setRows] = useState([]);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [crudTitle, setTitle] = useState("");
    const [reload, setReload] = useState(false);
    const [enabled, setEnabled] = useState(true);
    const [allProps, setAllProps] = useState([]);


    const classes = useStyles();
    const columns = [
        { name: 'id', title: 'ID', type: "label", shown: true, helper: false, helperText: '' },
        { name: 'enabled', title: 'Enabled', type: "label", shown: true, helper: false, helperText: '' },
        { name: 'clientId', title: 'Client ID', type: "text", shown: true, helper: true, helperText: 'Unique ID of the client' },
        { name: 'clientName', title: 'Client Name', type: "text", shown: true, helper: true, helperText: 'Client display name (used for logging and consent screen' },
        { name: 'clientUri', title: 'Client URI', type: "text", shown: true, helper: true, helperText: 'URI to further information about client (used on consent screen)' },
        { name: 'absoluteRefreshTokenLifetime', title: 'Refresh token lifetime', type: "int", shown: false, helper: true, helperText: 'Maximum lifetime of a refresh token in seconds. Defaults to 2592000 seconds / 30 days' },
        { name: 'accessTokenLifetime', title: 'Access token lifetime', type: "int", shown: false, helper: true, helperText: 'Lifetime of access token in seconds (defaults to 3600 seconds / 1 hour)' },
        { name: 'authorizationCodeLifetime', title: 'Authorization code lifetime', type: "int", shown: false, helper: true, helperText: 'Lifetime of authorization code in seconds (defaults to 300 seconds / 5 minutes)' },
        { name: 'deviceCodeLifetime', title: 'Device code lifetime', type: "int", shown: false, helper: true, helperText: 'Lifetime to device code in seconds (defaults to 300 seconds / 5 minutes)' },
        { name: 'identityTokenLifetime', title: 'Identity token lifetime', type: "int", shown: false, helper: true, helperText: 'Lifetime to identity token in seconds (defaults to 300 seconds / 5 minutes)' },
        { name: 'slidingRefreshTokenLifetime', title: 'Sliding refresh token lifetime', type: "int", shown: false, helper: true, helperText: 'Sliding lifetime of a refresh token in seconds. Defaults to 1296000 seconds / 15 days' },
        { name: 'requireClientSecret', title: 'Require secret', type: "bool", shown: false, helper: true, helperText: 'Specifies whether this client needs a secret to request tokens from the token endpoint (defaults to true)' },
        { name: 'alwaysIncludeUserClaimsInIdToken', title: 'Include token', type: "bool", shown: false, helper: true, helperText: 'When requesting both an id token and access token, should the user claims always be added to the id token instead of requiring the client to use the userinfo endpoint. Default is false.' },
        { name: 'allowAccessTokensViaBrowser', title: 'Via browser', type: "bool", shown: false, helper: true, helperText: 'Specifies whether this client is allowed to receive access tokens via the browser. This is useful to harden flows that allow multiple response types' },
        { name: 'grantTypes', title: 'Grant types', type: "textlist", shown: true, helper: true, helperText: 'Specifies the grant types the client is allowed to use. Use the GrantTypes class for common combinations.' },
        { name: 'redirectUris', title: 'Redirected URI\'s', type: "textlist", shown: true, helper: true, helperText: 'Specifies the allowed URIs to return tokens or authorization codes to.' },
        { name: 'postLogoutRedirectUris', title: 'Post logout redirected URI\'s', type: "textlist", shown: true, helper: true, helperText: 'Specifies allowed URIs to redirect to after logout.' },
        { name: 'allowedCorsOrigins', title: 'Allowed CORS', type: "textlist", shown: true, helper: true, helperText: 'If specified, will be used by the default CORS policy service implementations to build a CORS policy for JavaScript clients.' },
        { name: 'allowedScopes', title: 'Allowed scopes', type: "textlist", shown: true, helper: true, helperText: 'By default a client has no access to any resources - specify the allowed resources by adding the corresponding scopes names' }];

    useEffect(() => {
        if (reload === true) {
            setReload(false);
        }
        let mounted = true
        if (enabled === true) {

            clientDataService.getClients().then(o => {
                if (mounted) {
                    if (JSON.stringify(rows) !== JSON.stringify(o)) {
                        if (enabled === true) {

                            setRows(o);
                        } else {
                            let trueApis = o.filter(x => x.enabled === 'True');
                            setRows(trueApis);
                        }
                    }
                }
                console.log('Fetched clients: ', o)
            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

            clientDataService.getPossibleClientProps().then(o => {
                if (mounted) {
                    if (JSON.stringify(rows) !== JSON.stringify(o)) {
                        setAllProps(o);
                    }
                }
                console.log('Fetched client props:  ', o)
            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        }
    }, [rows, reload]);

    const editRow = (id) => {
        openDrawer("Edit", true, id);
    };

    const addRow = () => {
        openDrawer("Add", true, null);
    };

    const openDrawer = (title, open, id) => {
        setTitle(title);
        setDrawerOpen(open);
        setEditId(id);
    }

    const deleteRow = (id) => {
        setDeleteId(id);
        setOpenDeleteDialog(true);
    };

    const handleClose = () => {
        setOpenDeleteDialog(false);
    };

    const handleDelete = (id) => {
        setOpenDeleteDialog(false);
        clientDataService.deleteClient(id).then(() => setReload(true)).catch((error) => {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
            });
        });
    };


    const handleChange = (event) => {
        if (event.target.checked === true) {
            setEnabled(true);
            clientDataService.getClients().then(o => {
                setRows(o);
            })

        } else {
            setEnabled(false);
            clientDataService.getClients().then(o => {
                let trueClients = o.filter(x => x.enabled === 'True');
                setRows(trueClients);
            })
        }
    };



    const ActionFormatter = (row) => (
        <React.Fragment>
            <IconButton onClick={() => editRow(row.row.id)} title="Edit row">
                <EditIcon />
            </IconButton>
            <IconButton onClick={() => deleteRow(row.row.id)}>
                <DeleteIcon />
            </IconButton>

        </React.Fragment>
    );

    return (
        <div className={classes.container}>
            <div className={classes.buttonWell}>
                <div className={classes.rowFlex}>
                    <NavLink className={classes.navButton} to="/index">
                        <Button className={classes.backButton} color="primary" variant="contained" ><ArrowBackIcon></ArrowBackIcon> Back</Button>
                    </NavLink>
                    <Button className={classes.addButton} color="primary" variant="contained" onClick={() => addRow()}>
                        <AddIcon /> Add
                    </Button>
                </div>
                <Paper className={classes.paper}>
                    <div className={classes.toggleRow}>
                        <FormGroup className={classes.formGroup}>
                            <FormControlLabel onChange={handleChange} control={<Switch defaultChecked />} label="Show disabled" />
                        </FormGroup>
                    </div>
                    <ClientDevexGrid classname={classes.table} columns={columns} data={rows} hasActions={true} ActionFormatter={ActionFormatter} addRow={addRow}></ClientDevexGrid>
                </Paper>
                <AddEditDrawer setReload={setReload} rows={rows} title={crudTitle} openDrawer={openDrawer} drawerOpen={drawerOpen} editId={editId} columns={columns} allProps={allProps}></AddEditDrawer>
                <DeleteDialog open={openDeleteDialog} id={deleteId} handleClose={handleClose} handleDelete={handleDelete}></DeleteDialog>
            </div>
        </div>

    );
}

const useStyles = makeStyles({
    container: {
        position: 'relative',
        width: '100%',
        display: 'block',
        justifyContent: 'center',
        textAlign: 'center',
        verticalAlign: 'center'
    },
    toggleRow: {
        width: '100%',
        display: 'flex',
        justifyContent: 'end',
    },

    buttonWell: {
        marginTop: '25px',
        marginRight: '5%',
        marginLeft: '5%',

    },
    rowFlex: {
        display: 'flex',
        marginTop: '10px',
        marginBottom: '10px',
        justifyContent: 'space-between',
    },
    backButton: {
        marginLeft: '10px',
    },
    addButton: {

    },

    paper: {
        padding: '5px',
        height: '60%',
        width: "100%",
        overflow: "auto",
    },
    navButton: {
        //marginTop: '25px',
        textDecoration: 'none',
        //height: '80px',
        // width: '50%',
        alignContent: 'center',
    },
    styledButton: {
        marginTop: '25px',
        alignContent: 'center',
        marginBottom: '25px',
        //width: '50%',
        // height: '80px',
        fontSize: '20px !important'
    },

});